import React, { useState, useEffect, useRef } from "react";

import More from "./icons/More";

type LinkToRender = {
  label: string;
  onClick: Function;
  width: number;
};

// This is to keep only one menu open at a time
const Registry = {
  current: null as null | Function,
};

window.addEventListener("click", () => {
  if (Registry.current) {
    Registry.current();
  }
});

export default function Kebab({
  links,
  className,
  style,
  width,
}: {
  links: KebabMenuLink[] | Array<KebabMenuLink>[];
  className?: string;
  style?: Object;
  width?: number;
}) {
  const [visible, setVisible] = useState(false);
  const cleanup = useRef(() => setVisible(false));

  useEffect(() => {
    return () => {
      if (Registry.current === cleanup.current) {
        Registry.current = null;
      }
    };
  }, []);

  return (
    <div className={"kebab " + (className || "")} style={style || {}}>
      <div className="rel">
        <button
          className="block as-link reset"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            if (!visible) {
              if (Registry.current) {
                Registry.current();
              }
              Registry.current = cleanup.current;
              setVisible(true);
            } else {
              Registry.current = null;
              setVisible(false);
            }
          }}
        >
          <More size={20} />
        </button>
        {visible && (
          <div className="links">
            {links.map((link, i) => {
              const renderLink = ({ label, onClick, width }: LinkToRender) => (
                <button
                  key={i + label}
                  className="reset"
                  onClick={() => {
                    onClick();
                    setVisible(false);
                  }}
                  style={Object.assign(
                    {},
                    width ? { width: `${width}px` } : {}
                  )}
                >
                  {label}
                </button>
              );

              if (Array.isArray(link)) {
                return (
                  <div className="grid grid2 no-gap" key={i}>
                    {link.map(renderLink)}
                  </div>
                );
              } else {
                return renderLink(link as LinkToRender);
              }
            })}
          </div>
        )}
      </div>
    </div>
  );
}
